import { render, staticRenderFns } from "./CreateFodderModal.vue?vue&type=template&id=e454fe90&lang=pug&"
import script from "./CreateFodderModal.vue?vue&type=script&lang=js&"
export * from "./CreateFodderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports